import axios from '@api'

export default {
  getPartner () {
    return axios.get(`api/management/partner`)
  },
  savePartner (form) {
    return axios.post(`api/management/partner`,form)
  },
  removePartner(id){
    return axios.delete(`api/management/partner/${id}`)
  },
  getPartnerShare () {
    return axios.get(`api/management/partner/share`)
  },
  getCompanyPartner () {
    return axios.get(`api/management/getcompanypartner`)
  },
  saveSharePCT (json) {
    return axios.post(`api/management/savesharepct`, json)
  },
  getContract () {
    return axios.get(`api/management/contract`)
  },
  saveContract (form) {
    return axios.post(`api/management/contract`,form)
  },
  getContractByCompanyCode (companyCode) {
    return axios.get(`api/management/contract?companyCode=${companyCode}`)
  },
}